import { useTheme } from '../contexts/ThemeContext';
import lightModeLogo from '../assets/opsight-logo-light.svg';
import darkModeLogo from '../assets/opsight-logo-dark.svg';

interface OpsightLogoProps {
  size?: number;
  className?: string;
  variant?: 'light' | 'dark';
}

export const OpsightLogo = ({ size = 120, className = '', variant }: OpsightLogoProps) => {
  const { theme, isDark } = useTheme();
  
  // Determinar o tema da logo - usar variant se fornecido, senão usar o tema atual
  const logoTheme = variant !== undefined ? variant : (isDark ? 'dark' : 'light');
  
  // Calcular qual logo usar baseado no tema - cálculo direto para garantir reatividade
  const logoSrc = logoTheme === 'dark' ? darkModeLogo : lightModeLogo;
  
  // Calcular altura proporcional (viewBox original é 375x150)
  const aspectRatio = 375 / 150;
  const height = size / aspectRatio;

  return (
    <img
      key={`logo-${theme}-${logoTheme}`} // Force re-render when theme changes
      src={logoSrc}
      alt="Opsight"
      className={className}
      style={{
        width: `${size}px`,
        height: `${height}px`,
        display: 'block',
      }}
    />
  );
};

